export default "__VITE_ASSET__Wa4IkQWK__"